import { BudgetDto } from '@/types';

export const setBuyerBudget = (data: BudgetDto) => ({
    type: 'SET_BUYER_BUDGET',
    data,
});
